import { HttpBackend, HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, filter, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService {
  constructor(
    private httpClient: HttpClient,
    private httpBackend: HttpBackend,
    @Inject('BASE_URL') private baseUrl: string
  ) { }

  public requestPwdChange(username: any, isUserRegistration: boolean): Observable<any> {
    let newRequest = new HttpRequest(
      "PUT",
      `${this.baseUrl}api/Account/recovery`,
      {
        username,
        isUserRegistration
      },
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
    return this.httpBackend.handle(newRequest).pipe(filter((res) => res instanceof HttpResponse));
  }

  public getPwdChange(id: string): Observable<any> {
    let newRequest = new HttpRequest(
      "GET",
      `${this.baseUrl}api/Account/recovery`,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams({ fromObject: { g: id } }),
      }
    );
    return this.httpBackend.handle(newRequest).pipe(filter((res) => res instanceof HttpResponse)).pipe(map((res) => (res as HttpResponse<any>).body));
  }

  public submitPwdChange(pwdChangeContent: any): Observable<any> {
    let newRequest = new HttpRequest(
      "PUT",
      `${this.baseUrl}api/Account/change`,
      {
        g: pwdChangeContent.id,
        password1: pwdChangeContent.password,
        password2: pwdChangeContent.passwordAgain,
      },
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
    return this.httpBackend.handle(newRequest).pipe(filter((res) => res instanceof HttpResponse));
  }

  public getPwdPolicy(): Observable<any> {
    let newRequest = new HttpRequest(
      "GET",
      `${this.baseUrl}api/Account/password-policy`,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
    return this.httpBackend.handle(newRequest).pipe(filter((res) => res instanceof HttpResponse)).pipe(map((res) => (res as HttpResponse<any>).body));
  }
}
